/*
  Project: Congo Research Group
  Author: xfive
 */

import './vendor/lazyload';
import Tooltip from './modules/tooltip';
import './modules/focus-outline';
import './modules/comments';
import './modules/searched';
import './modules/navigation';
import './modules/hero';
import './modules/pillar-projects';
import './modules/posts';
import './modules/latest-resources';
import './modules/anchor-nav';
import './modules/language-switcher-display';

const tooltip = new Tooltip();
tooltip.init();



// WEBPACK FOOTER //
// ./src/scripts/app.js